<template>
  <transition name="cover-page">
    <div
      class="cpt-chat-full-dialog-cover flex-center min-w-[990px] fixed inset-0 px-[68px] py-[30px] z-[1000] bg-bl-mk"
      :style="{'z-index': zIndex}"
      @mousedown.passive="onMouseDown"
      @mouseup.passive="handleBgClick"
      ref="cover"
      v-if="show || keep_show_animation"
    >
      <div class="full-dialog-page flex-center wh-full relative max-w-[866px]">
        <div
          class="full-dialog-page-inner wh-full"
          :style="{'max-height': maxHeight + 'px'}"
        >
          <slot></slot>
          <div
            class="esc absolute w-[36px] h-[58px] right-[-52px] top-0 pointer"
            @click="$emit('esc')"
            v-if="showEsc"
          >
            <i class="iconfont icon-close-bold flex-center w-[36px] h-[36px]"></i>
            <div class="mt-[6px] text-[12px] text-tx-3 leading-[16px] text-center">ESC</div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapGetters } from "vuex"
import { PopupManager } from 'element-ui/lib/utils/popup'
export default {
  name: 'FullDialog',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    keep_show: {
      type: Boolean,
      default: false,
    },
    showEsc: {
      type: Boolean,
      default: true
    },
    maxHeight: {
      type: [String, Number],
      default: ''
    },
    hideWhenRouterChange: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapGetters(['active_dialogs']),
  },
  data() {
    return {
      uid: this._uid,
      zIndex: 2000,
      mouseDownDom: null,
      keep_show_animation: false // 为keep_show时保证transition动画，专门控制显隐变量
    }
  },
  watch: {
    show: {
      handler (v) {
        if (this.keep_show) return
        if (v) {
          this.zIndex = PopupManager.nextZIndex()
          this.$nextTick(()=>{
            this.initFullDialog()
          })
        } else {
          this.destroyFullDialog()
        }
      },
      immediate: true,
    },
    '$route' () {
      if (this.hideWhenRouterChange) {
        if (this.showEsc) {
          this.$emit('esc')
        } else {
          this.$emit('bgClick')
        }
      }
    }
  },
  mounted() {
    if (this.keep_show) {
      this.initFullDialog()
      this.keep_show_animation = true
    }
  },
  beforeDestroy() {
    this.destroyFullDialog()
  },
  methods: {
    initFullDialog() {
      if(!this.$el) return 
      window.addEventListener('keydown', this.handleKey)
      this.pushStack()
      document.body.appendChild(this.$el);
    },
    destroyFullDialog() {
      window.removeEventListener('keydown', this.handleKey)
      this.removeStack()
      if (this.$el?.parentNode) {
        this.$el.parentNode.removeChild(this.$el);
      }
    },
    onMouseDown(event) {
      this.mouseDownDom = event.target
    },
    handleBgClick() {
      if (this.mouseDownDom === this.$refs.cover) {
        this.$emit('bgClick')
        this.mouseDownDom = null
      }
    },
    pushStack () {
      this.active_dialogs.push(this.uid)
    },
    removeStack () {
      const index = this.active_dialogs.indexOf(this.uid)
      if (index > -1) {
        this.active_dialogs.splice(index, 1)
      }
    },
    handleKey(e) {
      if (e.keyCode === 27) {
        if (this.active_dialogs[this.active_dialogs.length - 1] === this.uid) {
          this.removeStack()
          this.$emit('esc')
        }
      }
    },
  },
}
</script>

<style lang="scss">
.cpt-chat-full-dialog-cover {
  .full-dialog-page {
    .esc {
      .icon-close-bold {
        background: $d-fl-1;
        border-radius: 50%;
        &::before {
          font-size: 16px;
          width: 16px;
          height: 16px;
          color: $d-tx-3;
        }
      }
    }
  }
}

.cover-page-enter-active,
.cover-page-leave-active {
  transition: all 0.2s cubic-bezier(0, 0, 0.58, 1);
  .full-dialog-page {
    transition: all 0.2s cubic-bezier(0, 0, 0.58, 1);
    transform: scale(1);
  }
}

.cover-page-enter, .cover-page-leave-to {
  transition: all 0s;
  opacity: 0;
  .full-dialog-page {
    transition: all 0s;
    transform: scale(1.1);
  }
}
</style>
